import * as rnLanguage from './language.service.js';

export default angular.module('rhino.components.language', ['ngCookies'])
  .service(rnLanguage.name, rnLanguage.default)
  .name;



// WEBPACK FOOTER //
// ../~/@printos/rhino/src/components/language/language.module.js